import React, { } from "react"
import templateC from "../../assets/templateC.webp"

function TempletPreview3({ isopen, setIsOpen }) {
    return (
        <>
            {(isopen === "C") && <div className="fixed inset-0 pt-10 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40">
                <button
                    onClick={() => setIsOpen(null)}
                    className="fixed top-2 right-2 z-20 text-white hover:text-red-500 text-4xl"
                >
                    &times;
                </button>
                <div className="fixed z-50 flex items-center justify-center backdrop-blur-sm bg-black/40">
                    <img src={templateC} alt="add" className="md:w-[460px] sm:w-[400px] w-[300px] h-[70vh] object-contain" />
                </div>
                <div className="backdrop-blur-sm bg-black/40 rounded-lg shadow-xl max-w-[520px] w-full relative overflow-y-auto h-[460px]">
                </div>
            </div>}
        </>
    )
}

export default TempletPreview3;